import { TravelRequestFilterState } from "../utils/travel-request-filter-state";

export function useInitialValues(): {
  emptyValues: TravelRequestFilterState | any;
  initialValues: TravelRequestFilterState | any;
} {
  const emptyValues = {
    text: "",
    sort: "createdOn_asc",
    responsiblePerson: [],
    senderIds: [],
    status: [],
    createdFromTo: {
      from: null,
      to: null
    }
  };

  const initialValues = {
    ...emptyValues
  };

  return {
    emptyValues,
    initialValues
  };
}
